// src/directives/clickOutside.js
export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function(event) {
      // Check if the clicked target is outside the element
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };

    // Attach the event listener to the document
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    // Remove the event listener when the directive is unmounted
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};
